import { IntroSectionData } from "../../../types/IntroSectionData";
import Img0 from '../../../assets/images/itm-3.png';
import Img1 from '../../../assets/images/itm-2.png';
import Img2 from '../../../assets/images/itm-6.png';
import Img3 from '../../../assets/images/itm-4.png';
import Img4 from '../../../assets/images/itm-7.png';

const introSectionData1: IntroSectionData = {
  sectionTitle: "Expertise",
  sectionSubtitle: "Détection et réponse.",
  translationNamespace: "dataCyber",
  tabsData: [
    {
      id: 0,
      title: "Intelligence",
      heading: "Recherche et investigation",
      text: "Nos experts sont formés aux techniques de recherche, d'investigation et disposent de sources de renseignement d'un large périmètre. Ils surveillent activement le Dark Web, les forums clandestins et les plateformes d'échange de données illicites.",
      key: "intelligence"
    },
    {
      id: 1,
      title: "Technique",
      heading: "Automatisation de la sécurité et DevSecOps",
      text: "Nous utilisons des crawlers spécialisés et des plateformes d'intelligence cyber pour analyser en temps réel les marchés noirs, forums hackers et bases de données compromises où les cybercriminels échangent des informations volées.",
      key: "technique"
    },
    {
      id: 2,
      title: "Analyse",
      heading: "Analyse et qualification des alertes",
      text: "Nos experts analysent et qualifient chaque alerte pour déterminer sa pertinence et son niveau de criticité. Nous vérifions l'authenticité des données divulguées, leur sensibilité et leur contexte pour évaluer l'impact potentiel sur votre entreprise.",
      key: "analyse"
    },
    {
      id: 3,
      title: "Remédiation",
      heading: "Gestion de crise et réponse",
      text: "En cas de fuite de données avérée, nous sommes là pour vous accompagner dans la gestion de crise et la mise en place de mesures de réponse aux incidents. Nous vous aidons à contenir la fuite, à identifier les causes et nous proposons les mesures de remediation.",
      key: "remediation"
    },
  ],
  fixedImageSrc: Img0,
  fixedImageAlt: "IT Monkeys Cloud Cyber",
};

export default introSectionData1;